export const genericErrorMessage =
  "Something went wrong. Please try again and, if the error persists, reach out to our support.";
